import { finish, error } from '../../../modules/sports/actions/move-list';

import api from '../../../api';

export function request(dispatch, { sport, list }) {
    api.patch('/sports/move', {list}).then(
        (sports) => dispatch(finish(sports)),
        ({ errors }) => dispatch(error(errors))
    );
}

